import { render } from "./Wavey.svg?vue&type=template&id=5eb5fca7"
const script = {}
script.render = render

export default script